import { createAsyncThunk } from "@reduxjs/toolkit";
import globaldata from "./mockData/globalData";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getglobaldata = async () => {


  // const response = await fetch(`${BASE_URL}/unipro/meta-data/global`, {
  //   method: "GET",
  //   credentials: 'include',
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  // if (!response.ok) {
  //   throw new Error("Internal Server Error");
  // }

  return globaldata;
};


export const getGlobalMetaData = createAsyncThunk("globaldata/getGlobalMetaData", async (credentials, { rejectWithValue }) => {
  try {
    const response = await getglobaldata();
    console.log("Mock global data:",response);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


